
    import {
        defineComponent,
    } from 'vue';
    import useFilterSelected from '@ve/components/filters/common/use/useFilterSelected';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import Tooltip from '@ve/components/tooltip/Tooltip.vue';

    export default defineComponent({
        name: 'is-exclusive-filter',
        components: {
            CheckBoxInput,
            Tooltip,
        },
        props: {
            selected: {
                type: Boolean,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, ctx) {
            return {
                ...useFilterSelected(props, ctx),
            };
        },
    });
